export interface ProfileFilterValueInterface {
  filterId?: string;
  filterLabel?: string;
  label?: string;
  value?: string;
}

export class ProfileFilterValue implements ProfileFilterValueInterface {
  public filterId?: string;
  public filterLabel?: string;
  public label?: string;
  public value?: string;

  constructor({
    filterId = undefined,
    filterLabel = undefined,
    label = undefined,
    value = undefined,
    }: ProfileFilterValueInterface) {
    this.filterId = filterId;
    this.filterLabel = filterLabel;
    this.label = label;
    this.value = value;
  }
}
